import { getAllPaymentMethods } from 'api/paymentMethods';

// Check if user has permission for payment methods:
// Payments - Mobile Payments , Account Settings - Bank Account, Dashboard - Dashboard
export async function getPaymentMethods(permissions): Promise<any[] | null> {
  const paymentPermission = permissions.find(
    (el) =>
      (el.menu === 'Payments' && el.sub_menu === 'Mobile Payments') ||
      (el.menu === 'Account Settings' && el.sub_menu === 'Bank Account') ||
      (el.menu === 'Dashboard' && el.sub_menu === 'Dashboard')
  );

  if (paymentPermission) {
    try {
      const res = await getAllPaymentMethods();
      return res.data;
    } catch (err) {
      console.error(err);
    }
  }

  return null;
}
